import Signal from 'libs/signals';
import api from 'api/api';
import history from '../../../../history';
import alertSignal from 'signals/Alert.signal';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import loaderSignal from 'signals/Loader.signal';

export const $list = Signal<{ lenders: any[], businessFavorites: any[] }>({
  lenders: [],
  businessFavorites: [],
});

const xFormAppliedFiltersToWhereClause = () => {
  const where: Record<string, any> = {};

  const params =
    Object.fromEntries(new URLSearchParams(history.location.search)) || {};

  if (params.id) {
    if (params.id.includes(',')) {
      where.id = { in: params.id.split(',').map((id) => Number(id.trim())) };
    } else {
      where.id = { in: [Number(params.id)] };
    }
  }

  if (params.name) {
    where.fundingProgramId = { in: [params.name] };
  }

  return where;
};

async function fetchAndSetBusinessFavorites() {
  const businessFavorites = await api.get({
    path: '/businessFavorites',
    options: {},
  });

  $list.update({ businessFavorites });
}

export async function fetchAndSetOrganizationData(): Promise<any> {
  try {
    loaderSignal.update({
      isContentLoading: true,
    });

    const lenders = await api.get({
      path: '/lenders',
      options: {
        orderBy: {
          name: 'asc',
        },
        // where: xFormAppliedFiltersToWhereClause(),
        // orderBy: xFormSortToOrderByClause(),
        include: {
          fundingProgramMemberships: {
            include: {
              fundingProgram: true,
            },
          },
        },
      },
    });

    await fetchAndSetBusinessFavorites();

    $list.update({ lenders });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      // @ts-expect-error does not know it's a regular error
      message: error.message,
      error,
    });
  } finally {
    loaderSignal.update({ isContentLoading: false });
  }
}

export const saveFinancingOpportunity = async ({
  lenderId,
  ventureCapitalFirmId,
}: { lenderId: number | null, ventureCapitalFirmId: number | null }): Promise<any> => {
  loaderSignal.update({
    isContentLoading: true,
    message: 'Saving business opportunity...',
  });
  try {
    await api.post({
      path: '/businessFavorites',
      body: {
        data: {
          businessId: userAccountSignal.value.userData?.account?.business?.id,
          ventureCapitalFirmId,
          lenderId,
        },
      },
    });
    return alertSignal.update({
      type: 'notification',
      variant: 'success',
      message: 'Successfully saved opportunity.',
    });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      // @ts-expect-error does not know it's a regular error
      message: error.message,
      error,
    });
  }
};

export const removeSavedOpportunity = async (favoriteId: number): Promise<any>  => {
  try {
    loaderSignal.update({ isContentLoading: true });
    await api.delete({
      path: '/businessFavorites',
      body: {
        where: {
          id: favoriteId,
        },
      },
    });
    return alertSignal.update({
      type: 'notification',
      variant: 'success',
      message: 'Successfully unsaved opportunity.',
    });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      // @ts-expect-error does not know it's a regular error
      message: error.message,
      error,
    });
  } finally {
    loaderSignal.update({ isContentLoading: false });
  }
};

export const handleSaveOpportunityFromSearchResults = async ({
  lenderId, ventureCapitalFirmId,
}: { lenderId: number | null, ventureCapitalFirmId: number | null
  }): Promise<any> => {
  try {
    await saveFinancingOpportunity({ lenderId, ventureCapitalFirmId });
    await fetchAndSetBusinessFavorites();
  } catch (error) {
    alertSignal.update({
      type: 'alert',
      error,
      // @ts-expect-error does not know it's a regular error
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};

export const handleRemoveSavedOpportunityFromSearchResults = async (
  favoriteId: number
): Promise<any> => {
  try {
    await removeSavedOpportunity(favoriteId);
    await fetchAndSetBusinessFavorites();
  } catch (error) {
    alertSignal.update({
      type: 'alert',
      error,
      // @ts-expect-error does not know it's a regular error
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};
